import styled from "styled-components";

export const NavHeaderContainer = styled.div`
	height: 100vh;
	cursor: pointer;
	width: 52px;
	background-color: rgba(18, 6, 45, 1);
	display: flex;
	flex-direction: column;
	row-gap: 0.5vw;
	justify-content: flex-start;
	align-items: center;
	padding: 10px 0px;
	box-sizing: border-box;
	${({ theme }) =>
    theme.media.monitor(
      `
        width: 65px;
    	`,
    )}
`

export const NavLogo = styled.div`
	width: 34px;
	height: 34px;
	background-image: url('/assets/nav-logo.png');
	background-size: cover;
	${({ theme }) =>
    theme.media.monitor(
      `
				width: 40px;
				height: 40px;
    	`,
    )}
`

export const StyledLine = styled.div`
	width: 18px;
	height: 1px;
	background-color: rgba(255, 255, 255, 1);
	margin-top: 10px;
`

export const StyledMenu = styled.div`
	width: 34px;
	height: 34px;
	background-color: rgba(90, 30, 219, 1);
	border-radius: 5px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 20px;
	svg {
		font-size: 18px;
	}
	${({ theme }) =>
    theme.media.monitor(
      `
				width: 40px;
				height: 40px;
				svg {
					font-size: 22px;
				}
    	`,
    )}
`